<script setup lang="ts">
/**
 * Секция «Действия из расшифровки» — макет 12-6.
 *
 * Стоит сразу под конспектом: сначала что было, потом что с этим делать. Своим
 * компонентом — потому что место у неё зависит от конспекта: он есть — она под
 * ним, его нет (обработка сорвалась) — она открывает ленту.
 */
import { useI18n } from 'vue-i18n'

import MeetingActionCard from './MeetingActionCard.vue'

import type { Note } from '../notes'

defineProps<{
  actions: Note[]
  /** Проект встречи — предзаполняет форму задачи */
  projectId: string
}>()

const { t } = useI18n()
</script>

<template>
  <section v-if="actions.length" class="mactions">
    <h3 class="mactions__title">{{ t('meetings.ai.actions', { count: actions.length }) }}</h3>

    <!-- Предупреждение под заголовком, а не под последней карточкой: его
         читают до того, как нажать, а не после. -->
    <p class="mactions__hint">{{ t('meetings.ai.actionsHint') }}</p>

    <MeetingActionCard
      v-for="action in actions"
      :key="action.id"
      :note="action"
      :project-id="projectId"
    />
  </section>
</template>

<style scoped>
.mactions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mactions__title {
  margin: 0;
  color: var(--color-text-primary);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-semibold);
  line-height: 20px;
}

.mactions__hint {
  margin: 0;
  color: var(--color-text-muted);
  font-size: var(--font-size-caption);
  line-height: 16px;
}
</style>
